var map = {
	"./ASC.png": 5622,
	"./DESC.png": 3541,
	"./admin.png": 1715,
	"./close-btn.png": 2447,
	"./delete.png": 7738,
	"./edit.png": 1169,
	"./home.png": 4788,
	"./icon1.png": 8715,
	"./logout.png": 3408,
	"./profile.png": 1132,
	"./settings.png": 3424,
	"./settings2.png": 4021,
	"./upload.png": 8519
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7872;